import _ from 'lodash'

import pt from '../../../locales/pt/common.json'

type TranslateValues = Record<string, unknown>

type TranslateOptions = {
  fallback?: string
}

const interpolate = (template: string, values?: TranslateValues) => {
  if (!values) return template

  return template.replace(/\{\{(\w+)\}\}/g, (_, key: string) =>
    String(values[key] ?? '')
  )
}

export const useTranslation = (_namespace = 'common') => {
  const t = (
    key: string,
    values?: TranslateValues,
    options?: TranslateOptions
  ) => {
    const resolved = _.get(pt, key)

    if (typeof resolved === 'string') {
      return interpolate(resolved, values)
    }

    return options?.fallback ?? key
  }

  return { t, lang: 'pt' as const }
}
